import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

interface SelectAllDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedCount: number;
  totalCount: number;
}

const SelectAllDialog: React.FC<SelectAllDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedCount,
  totalCount,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">Select All Rows</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {`All ${selectedCount} rows on this page are selected. Select all ${totalCount} rows?`}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="primary" autoFocus>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default SelectAllDialog;
